import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
} from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import Fuse from "fuse.js";
import SearchRounded from "@material-ui/icons/SearchRounded";

import clsx from 'clsx'
import { withRouter } from "react-router-dom";
import { Modal } from "react-bootstrap";
import {
  Avatar,
  Paper,
  Divider,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Checkbox,
  InputBase,
  Typography,
  Grid,
  Button,
  IconButton,
  ClickAwayListener,
  Tooltip,
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import * as moment from "moment";
import "@fontsource/montserrat";


const useStyles = makeStyles((theme) => ({
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  listContainer: {
    width: "100%",
    paddingLeft: "10px",
    paddingRight: "10px",
  },
  goalLabel: {
    marginBottom: "10px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
    textAlign: "center",
    width: "100%",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    padding: "0px 0px",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "1px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  checkboxRoot: {
    color: "#3AC2D7 !important",
    "&:hover": {
      backgroundColor: "none",
    },
  },
  objectFit: {
    objectFit: "contain",
  },
  spanWidth: {
    width: "90%",
  },
  searchField: {
    border: "1px solid rgba(0,0,0,0.3)",
    padding: "3px 10px 3px 50px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    borderRadius: "4px",
    margin: "10px 0",
  },
  goalLabel3: {
    marginBottom: "10px",
    fontSize: "14px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
  },
  listOverflow: {
    width: "100%",
    height: "300px",
    overflowY: "scroll",
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
  wordCounter: {
    textAlign: "right",
    fontfamily: "Montserrat",
    fontSize: "14px",
    marginTop: "4px",
    color: "rgba(0,0,0,0.5)",
  },
  leftTitle: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    padding: "0px 0px",
  },
  backButton: {
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
    color: "#3ac2d7",
    textTransform: "none",
    width: "200px",
    fontWeight: "bold",
    border: "2px solid #3ac2d7",
    transition: "0.3s",
    "&:focus": {
      color: "#3ac2d7",
      border: "2px solid #3ac2d7",
    },
    "&:hover": {
      backgroundColor: "#3ac2d7",
      color: "#fff",
    },
  },
  saveButton: {
    backgroundColor: "#fff",
    fontFamily: "Montserrat",
    color: "#3ac2d7",
    textTransform: "none",
    width: "200px",
    fontWeight: "bold",
    transition: "0.3s",
    marginLeft: "15px",
    border: "2px solid #3ac2d7",
    "&:hover": {
      backgroundColor: "#3ac2d7",
      color: "#fff",
    },
  },
  offlineButton: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    backgroundColor: "#b499c7",
    color: "#fff",
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#b499c7",
    },
  },
  onlineButton: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    backgroundColor: "#b499c7",
    color: "#fff",
    opacity: 0.6,
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
      backgroundColor: "#b499c7",
    },
  },
  commonInput: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "16px",
    color: "rgba(0,0,0,0.5)",
    width: "100%",
    border: "1px solid rgba(0,0,0,0.3)",
    borderRadius: "4px",
    padding: "5px 10px",
  },
  goalLabel: {
    marginTop: "20px",
    marginBottom: "10px",
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.4)",
  },
  boxShadow: {
    boxShadow: theme.shadows[7]
  }
}));

const NumberSurface = (props) => {
  return (
    <Box
      style={{
        height: "34px",
        width: "34px",
        borderRadius: "50%",
        border: "2px solid #3ac2d7",
        display: "flex",
        justifyContent: "center",
        marginRight: "10px",
        fontSize: "16px",
        fontFamily: "Montserrat",
        alignItems: "center",
      }}
    >
      {props.content}
    </Box>
  );
};

const CustomModal2 = (props) => {
  const { parentData } = props;
  const classes = useStyles();
  const [offline, setOffline] = useState(true);
  const [offlineData, setOfflineData] = useState("");
  const [meetingLink, setMeetingLink] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [hours, setHours] = useState("");
  const [goal1, setGoal1] = useState("");
  const [goal2, setGoal2] = useState("");
  const [goal3, setGoal3] = useState("");
  const [outcome, setOutcome] = useState("");
  const [title, setTitle] = useState("");
  const [searchTooltipOpen, setSearchTooltipOpen] = useState(false);
  const [searchStartupTooltipOpen, setSearchStartupTooltipOpen] =
    useState(false);
  const [searchContent, setSearchContent] = useState();
  const [searchList, setSearchList] = useState([]);
  const [searchStartupContent, setSearchStartupContent] = useState();
  const [touched, setTouched] = useState(false);

  const { modalOpen } = props;

  const [error, setError] = useState();
  const [titleError, setTitleError] = useState();
  const [timeError, setTimeError] = useState();
  useEffect(() => {
    if (!searchContent) {
      setSearchTooltipOpen(false);
    } else {
      setSearchTooltipOpen(true);
    }
  }, [searchContent]);
  useEffect(() => {
    if (!searchStartupContent) {
      setSearchStartupTooltipOpen(false);
    } else {
      setSearchStartupTooltipOpen(true);
    }
  }, [searchStartupContent]);
  useEffect(() => {
    if (props?.modalData !== undefined) {
      
      setDate(moment(props?.modalData?.sessionDate).format("YYYY-MM-DD"));
      setHours(moment(props?.modalData?.sessionDate).format("hh:mm A"));
    }
  }, [props.modalData]);

  useEffect(() => {
    setOffline(true);
    setOfflineData("NA");
    setDate("");
    setTime("");
    setHours("1");
    setGoal1("");
    setGoal2("");
    setGoal3("");
    setOutcome("");
    setTitle("");
    setTouched(false);
    setTimeError("");
    setTitleError("");
  }, [modalOpen]);
  const checkboxRef = useRef([]);
  const checkboxRef2 = useRef([]);

  useEffect(() => {
    checkboxRef.current = checkboxRef.current.slice(
      0,
      props.allMentorList?.length
    );
    checkboxRef2.current = checkboxRef2.current.slice(
      0,
      props.allStartupList?.length
    );
  }, [props.allMentorList]);
  const handleClose = () => {
    props.setModalOpen(false);
    // props.openEditModal(false);
  };
  useEffect(() => {
    if (props.EditModalValue) {
      setDate(moment(props?.modalData.sessionStart).format("YYYY-MM-DD"));
      setTime(moment(props?.modalData.sessionStart).format("HH:mm:ss"));
      setHours(props?.modalData.sessionDuration);
      if (props?.modalData.sessionFormat === "ONLINE") {
        setOffline(false);
      }
      setGoal1(props?.modalData.sessionGoals[0]);
      if (props?.modalData.sessionGoals[1] !== undefined)
        setGoal2(props?.modalData.sessionGoals[1]);
      if (props?.modalData.sessionGoals[2] !== undefined)
        setGoal3(props?.modalData.sessionGoals[2]);
      setOutcome(props?.modalData.desiredOutcomes);
    }
  }, [props.EditModalValue]);
 
  
  return (
    <Modal
      size="lg"
      show={props.modalOpen}
      onHide={() => props.setModalOpen(false)}
      aria-labelledby="example-modal-sizes-title-lg"
      dialogClassName={clsx("mentorship_engagement_summary--modal_width speakermodalparent")}
      contentClassName={clsx("mentorship_engagement_summary--modal_content_width speakermodal", classes.boxShadow)}
      style={{ borderRadius: "7px" }}
    >
      <Modal.Header
        className="d-flex"
        style={{ justifyContent: "space-between" }}
      >
        <Modal.Title className="modalHeading d-flex justify-content-center">
         
          SELECT SPEAKER
        </Modal.Title>
        <div className="newuserTooltip">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
          <span
            className="tooltiptext  close-window"
            style={{ left: "-130px", top: "2px", width: "130px" }}
          >
            Close Window
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Box style={{ padding: "35px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} className={classes.flex}>
              <NumberSurface content="8" />
              <Typography className={classes.leftTitle}>
                {"Select Speaker"}
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12}>
              
              <Paper elevation={0} className={classes.listContainer}>
                <Box
                  className={classes.flex}
                  style={{ justifyContent: "space-between" }}
                >
                  <Box style={{ width: "100%" }}>
                    <Tooltip
                      open={searchTooltipOpen}
                      interactive
                      classes={{
                        tooltip: classes.tooltip,
                        tooltipArrow: classes.tooltipArrow,
                      }}
                      PopperProps={{
                        disablePortal: true,
                      }}
                      arrow
                      title={
                        <>
                          <ClickAwayListener
                            onClickAway={() => setSearchTooltipOpen(false)}
                          >
                            <Paper
                              elevation={4}
                              style={{
                                padding: "15px",
                                height: "300px",
                                width: "400px",
                                overflowY: "scroll",
                              }}
                            >
                              {searchList?.map((item) => (
                                <>
                                  <ListItem alignItems="center">
                                    <ListItemSecondaryAction>
                                      <Checkbox
                                        edge="end"
                                        checked={props?.speakerArray?.includes(item.id)}
                                        classes={{
                                          root: classes.checkboxRoot,
                                        }}
                                        onChange={(e) => {
                                          const index =
                                            props.allMentorList?.findIndex(
                                              (ele) => ele.id === item.id
                                            );
                                          if (index >= 0) {
                                            checkboxRef.current[index].click();
                                          }
                                          props.onBroadcastSelectionChange(
                                            item,
                                            e.target.checked
                                          );
                                        }}
                                      />
                                    </ListItemSecondaryAction>
                                    <ListItemAvatar>
                                      <Avatar
                                        classes={{
                                          img: classes.objectFit,
                                        }}
                                        src={item.image}
                                      ></Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={
                                        <>
                                          <Typography
                                            style={{
                                              fontFamily: "Montserrat",
                                              fontSize: "16px",
                                            }}
                                          >
                                            {item?.name}
                                          </Typography>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                  <Divider
                                    variant="inset"
                                    style={{ height: "2px" }}
                                  />
                                </>
                              ))}
                            </Paper>
                          </ClickAwayListener>
                        </>
                      }
                    >
                      <Box style={{ position: "relative" }}>
                        <SearchRounded
                          style={{
                            position: "absolute",
                            left: "15px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "rgba(0,0,0,0.3)",
                          }}
                        />
                        <InputBase
                          fullWidth
                          placeholder="Search Mentors"
                          value={searchContent}
                          className={classes.searchField}
                          onChange={(e) => {
                            setSearchContent(e.target.value);
                            const fuse = new Fuse(props.allMentorList, {
                              keys: ["name"],
                              threshold: 0.1,
                            });
                            const matches = fuse.search(e.target.value);
                            const results = matches.map((item) => item.item);
                            setSearchList(results);
                          }}
                        />
                      </Box>
                    </Tooltip>
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "0 20px",
                      }}
                    >
                      <Typography
                        className={classes.goalLabel3}
                        style={{ flex: 1 }}
                      >
                        TOTAL SPEAKERS: {props.allMentorList?.length}
                      </Typography>

                     
                    </Box>
                    <Typography
                          className={classes.goalLabel3}
                          style={{ textAlign: "right", marginRight: "40px" }}
                        >
                          Selected:{" "}
                          {
                            props?.speakerArray?.length
                          }
                        </Typography>
                    <Box className={classes.listOverflow}>
                      <List className={classes.list}>
                        {props.allMentorList?.map((datum, index) => (
                          <>
                            <ListItem alignItems="center">
                              <ListItemSecondaryAction>
                                <Checkbox
                                  edge="end"
                                  inputRef={(el) =>
                                    (checkboxRef.current[index] = el)
                                  }
                                  checked={props?.speakerArray?.includes(datum.id)}
                                  classes={{
                                    root: classes.checkboxRoot,
                                  }}
                                  onChange={(e) => {
                                   
                                      if(e.target.checked) {
                                        parentData(prevState => [
                                          ...prevState, 
                                          {name: datum.name, 
                                            id: datum.id
                                          }
                                        ])
                                      } else {
                                        parentData(prevState => prevState.filter(i => i.id !== datum.id))
                                      }
                                   
                                    props.onBroadcastSelectionChange(
                                      datum,
                                      e.target.checked
                                    );
                                    if(e.target.checked) {
                                      props.setSpeakerArray([...props.speakerArray, datum.id])
                                    } else {
                                      props.setSpeakerArray(props?.speakerArray?.filter(item => item !== datum.id))
                                    }
                                  }}
                                />
                              </ListItemSecondaryAction>
                              <ListItemAvatar>
                                <Avatar
                                  classes={{
                                    img: classes.objectFit,
                                  }}
                                  src={datum.image}
                                ></Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary={
                                  <>
                                    <Typography
                                      style={{
                                        fontFamily: "Montserrat",
                                        fontSize: "16px",
                                      }}
                                    >
                                      {datum?.name}
                                    </Typography>
                                  </>
                                }
                              />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                          </>
                        ))}
                      </List>
                    </Box>
                  </Box>
                  
                </Box>
                
              </Paper>
            </Grid>
          </Grid>

          <Box
            style={{
              display: "flex",
              justifyContent: "space-around",
              padding: "50px 25% 0 25% ",
            }}
          >
            <Box>
              <Button
                onClick={() => {
                  props.setModalOpen(false);
                 
                }}
                className={classes.backButton}
                disableRipple
              >
                CLOSE
              </Button>
            </Box>
          </Box>
        </Box>
        {/* )} */}
      </Modal.Body>
    </Modal>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  openLoader,
  closeLoader,
})(withRouter(CustomModal2));
